import React from "react";
import type {
  DaperImages,
  DaperNewsletter,
  DaperPerson,
  DaperStory,
} from "@foundation/intercom-client";

export interface StoryWithImage extends DaperStory {
  image: DaperImages | undefined;
}

export type DaperStoryWithImage = DaperStory & { image?: DaperImages };
export type DaperStoryWithImageAndAuthor = DaperStory & {
  image?: DaperImages;
} & { author?: DaperPerson };
export type DaperStoryWithNewsletter = DaperStory & {
  newsletter: DaperNewsletter;
};
export type DaperStoryWithNewsletterImage = DaperStory & {
  newsletter: DaperNewsletter;
} & { image?: DaperImages };

export type Topic = {
  name: string;
  id: string;
  isFollowedByUser: boolean;
};

export type TopicListItemProps = {
  story: DaperStoryWithImage;
  index: number;
  topicName: string;
};

export type SingleTopicStoriesProps = {
  stories: DaperStory[];
  topic: Topic;
  numberOfRows: number;
  followTopicCallback: (topicId: string, addInPlace?: boolean) => void;
  rootRef?: React.RefObject<HTMLDivElement>;
  isSignedIn: boolean;
};

export type TopicsWithStories = {
  [topicId: string]: StoryWithImage[];
};

export const PanelTypes = {
  TagPickerType: "TagPicker",
  TopicCard: "TopicCard",
  LoadingTopicCard: "LoadingTopicCard",
} as const;

export type TopicPickerPanelProps = {
  type: (typeof PanelTypes)["TagPickerType"];
  props: {
    topics: Topic[];
    followTopicCallback: (topicId: string) => void;
    unfollowTopicCallback: (topicId: string) => void;
    rootRef?: React.Ref<HTMLDivElement>;
    isSignedIn: boolean;
  };
};

export type SingleTopicStoriesPanelProps = {
  type: (typeof PanelTypes)["TopicCard"];
  props: Pick<
    SingleTopicStoriesProps,
    "rootRef" | "topic" | "stories" | "followTopicCallback" | "isSignedIn"
  >;
};

export type LoadingTopicCardProps = {
  type: (typeof PanelTypes)["LoadingTopicCard"];
  // eslint-disable-next-line @typescript-eslint/ban-types
  props: {};
};

export type UserTopicPanelProps =
  | TopicPickerPanelProps
  | SingleTopicStoriesPanelProps
  | LoadingTopicCardProps;

export interface AutofillData {
  type: string;
  args:
    | {
        [key: string]: unknown;
      }
    | string;
}
